<template>
  <base-dialog
    :title="title"
    :subtitle="subtitle"
    :description="description">

    <table style="width: 100%; table-layout: fixed;">
      <tr>
        <td v-for="shape in shapes.slice(0, 4)" :key="shape.value" @click="onShapeSelected(shape)" :class="{ 'selected': shape == value }">
          <div class="img-wrap">
            <img :src="shapeImage(shape.value)" />
          </div>
          {{ shape.label }}
        </td>
      </tr>

      <tr>
        <td v-for="shape in shapes.slice(4, 8)" :key="shape.value" @click="onShapeSelected(shape)" :class="{ 'selected': shape == value }">
          <div class="img-wrap">
            <img :src="shapeImage(shape.value)" />
          </div>
          {{ shape.label }}
        </td>
      </tr>
    </table>
  </base-dialog>
</template>


<script>
  import Vue from 'vue'
  import BaseDialog from "./BaseDialog"
  import { mapState } from 'vuex'
  import { roomShapes } from '../../api/constants'

  export default {
    props: [
      'title',
      'subtitle',
      'description',
      'value'
    ],

    methods: {
      onShapeSelected(shape) {
        this.$emit('input', shape)
      },
      shapeImage(floorShape) {
        return require('../../assets/options/pohjanmuoto_' + floorShape.toLowerCase() + '.png')
      }
    },

    data() {
      return {
        shapes: roomShapes
      }
    },

    components: {
      BaseDialog
    }
  }
</script>

<style scoped>
  .img-wrap {
    vertical-align: middle;
    text-align: center;
    height: 80px;
    line-height: 80px;
  }
  .img-wrap img {
    max-width: 100%;
  }
  td {
    padding: 3px;
    cursor: pointer;
    text-align: center;
    font-size: small;
    border-bottom: 5px solid white;
  }
  td:hover {
    background-color: #eee;
    color: #32cd32;
    border-color: #32cd32;
  }
  .selected {
    color: green;
    border-color: green;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/BaseShapeDialog.vue